import ArrowBack from "@mui/icons-material/ArrowBack";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { Box, Pagination, PaginationItem, useTheme } from "@mui/material";

export default function PaginationControls({
  numPages,
  page,
  setPage,
}: {
  numPages: number;
  page: number;
  setPage: (params: number) => void;
}) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        marginBottom: theme.spacing(3),
      }}
    >
      <Pagination
        sx={{
          ul: {
            "& .MuiPaginationItem-root.MuiPaginationItem-root.Mui-selected": {
              background: theme.palette.primary.main,
              color: theme.palette.common.white,
            },
          },
        }}
        disabled={numPages === 1}
        count={numPages}
        page={page + 1}
        onChange={(_event: unknown, value: number) => {
          setPage(value - 1);
        }}
        renderItem={(item) => (
          <PaginationItem
            {...item}
            slots={{
              previous: ArrowBack,
              next: ArrowForward,
            }}
          />
        )}
      />
    </Box>
  );
}
